import Table from 'components/commons/table'
import { TABLE_WAITLIST } from 'configs/user/user-detail/configTableWaitlist'

export const TabWaitlist = ({ dataList, query, onChangeQuery, isLoading }) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_WAITLIST.name}
                columns={TABLE_WAITLIST.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
        </div>
    )
}
